var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-bar"},[_c('v-app-bar',{staticClass:"primary",attrs:{"app":"","height":"60"}},[_c('NavigationDrawer'),_c('p',{staticClass:"font-weight-bold title mt-4 white--text ml-5"},[_vm._v(" Yo Yo Trade ")]),_c('v-spacer'),_c('p',{staticClass:"mt-4 white--text"},[_vm._v(" "+_vm._s(_vm.currentUser.username)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }